import React, { useMemo } from 'react';

import { HStack, Skeleton } from '@rtkwlf/fenrir-react';
import uniqueId from 'lodash/uniqueId';

import { Card } from '@packages/components/card/card';
import { LayoutGrid } from '@packages/insights-widgets/layout/styled-layouts/styled-layouts';

const WidgetLoaderCell = () => {
  return (
    <Card
      data-testid="card"
      position="relative"
      width="full"
      height="full"
      paddingTop="medium"
      paddingRight="medium"
      paddingBottom="smedium"
      paddingLeft="medium"
    >
      <Skeleton height="1.5rem" width="66%" marginBottom="zero" />
      <Skeleton height="0.75rem" width="33%" marginBottom="smedium" />
      <Skeleton flex="auto" marginBottom="medium" />
    </Card>
  );
};

type DashboardSkeletonLoaderProp = {
  widgetCount: number;
};

export const DashboardSkeletonLoader = ({
  widgetCount,
}: DashboardSkeletonLoaderProp) => {
  const skeletonList = useMemo(
    () => [...Array(widgetCount)].map(() => uniqueId()),
    [widgetCount],
  );
  return (
    <>
      <HStack
        marginBottom="smedium"
        alignItems="center"
        justifyContent="space-between"
        width="full"
      >
        <Skeleton height="2.5rem" width="20rem" />
        <Skeleton height="2rem" width="18rem" />
      </HStack>

      <hr />

      <Skeleton height="1rem" width="9rem" marginTop="large" />
      <Skeleton height="0.5rem" width="18rem" />
      <Skeleton height="1.5rem" width="40rem" marginBottom="large" />

      <LayoutGrid data-testid="skeleton">
        {skeletonList.map((id) => (
          <WidgetLoaderCell key={id} />
        ))}
      </LayoutGrid>
    </>
  );
};
